/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext } from 'react';
import type {
  VueFormatterServiceInterfaceV1,
  LocaleServiceV1,
  AudiFootnoteRefernceServiceScopeManagerInterfaceV3,
} from '../feature-service-types';

type ContentContextState = {
  featureAppId: string;
  content?: any;
  trackingService?: any;
  loggerService?: any;
  localeService: LocaleServiceV1;
  vueFormatterService: VueFormatterServiceInterfaceV1;
  footnoteReferenceService: AudiFootnoteRefernceServiceScopeManagerInterfaceV3;
};

export const ContentContext = createContext<ContentContextState>({
  featureAppId: '',
  loggerService: console,
  localeService: {} as LocaleServiceV1,
  vueFormatterService: {} as VueFormatterServiceInterfaceV1,
  footnoteReferenceService: {} as AudiFootnoteRefernceServiceScopeManagerInterfaceV3,
});
